module.exports = __webpack_public_path__ + "img/8.04b48a19.png";